<template>
    <div />
</template>

<script>

import Pusher from "pusher-js";

export default {
  data() {
    return {
      pusher: null
    };
  },

  methods: {
    subscribeToPusher() {
      if (!this.pusher) {
        this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
          cluster: "us2",
          forceTLS: true,
          authEndpoint: process.env.VUE_APP_API_HOST + "/auth/pusher",
          auth: {
            headers: {
              "Authorization": sessionStorage.getItem("access_token")
            }
          }
        });
      }
      // CTM Call Events
      const channel = this.pusher.subscribe("private-incoming-call");
      channel.bind("App\\Events\\IncomingCall", data => {
        this.handleIncomingCall(data.payload);
      });
    },

    unsubscribeFromPusher() {
      this.pusher.disconnect();
      this.pusher = null;
    },

    handleIncomingCall(call) {
      if (call.ctm_user_id === this.$store.state.user.me.ctm_id) {
        this.$emit("incomingCall", call);
      }
    }
  },

  created() {
    this.subscribeToPusher();
  },

  beforeDestroy() {
    this.unsubscribeFromPusher();
  }
};
</script>
